export function interpolate(
  value: number,
  inputRange: readonly number[],
  outputRange: readonly number[],
): number {
  if (inputRange.length < 2 || outputRange.length < 2) {
    throw new Error('Input and output ranges must have at least 2 values')
  }

  if (inputRange.length !== outputRange.length) {
    throw new Error('Input and output ranges must have the same length')
  }

  for (let i = 1; i < inputRange.length; i++) {
    if (inputRange[i] < inputRange[i - 1]) {
      throw new Error('Input range must be in ascending order')
    }
  }

  let i = 0
  for (; i < inputRange.length - 1; i++) {
    if (value < inputRange[i + 1]) {
      break
    }
  }

  if (value <= inputRange[0]) {
    return outputRange[0]
  } else if (value >= inputRange[inputRange.length - 1]) {
    return outputRange[outputRange.length - 1]
  }

  const t = (value - inputRange[i]) / (inputRange[i + 1] - inputRange[i])
  return outputRange[i] + t * (outputRange[i + 1] - outputRange[i])
}
